import React from 'react';
import { connect } from 'react-redux';
import AnswerLogs from './AnswerLogs';
import { I } from '../../../common/v5/config';
import { M_AI_ANSWER_LOGS } from '../../../common/v5/constants';
import { autoAnswerLogsSelector, getAgentListSelector, getAdminListWipSelector } from '../../../redux/selectors/admin';
import { getAIAnswerLogsList, agentList, postAdminAIAnswerLogsRating } from '../../../redux/actions/async/admin';
import { changeAdminView } from '../../../redux/actions/admin';
import { onlyActiveAreasSelector } from '../../../redux/selectors/workflow';
import { onceAgents, onceChannels, onceAgentAreas } from '../../../redux/actions/async/workflow';


const mapStateToProps = (state) => {
	let servicesName = [];
	if(state.server) {
		servicesName = state.server.servicesName;
	}
	
	const mappedProps = {
		list: autoAnswerLogsSelector(state),
		agentList: getAgentListSelector(state),
		channels: servicesName,
		areaList: onlyActiveAreasSelector(state),
		isLoading: getAdminListWipSelector(state),
	};
	return mappedProps;
};

const mapDispatchToProps = (dispatch, _this) => {
	return {
		onLoad: () => {
			dispatch(changeAdminView(M_AI_ANSWER_LOGS));
			dispatch(agentList());
			dispatch(onceAgentAreas());
			
		},
		onFilterByListby: (params) => {
			dispatch(getAIAnswerLogsList(params));
		},
		onRateAnswer: (params) => {
			dispatch(postAdminAIAnswerLogsRating(params));
		}
	};
};

const AnswerLogsCtnr = connect(mapStateToProps, mapDispatchToProps)(AnswerLogs);


export default AnswerLogsCtnr;